const ShimmerViewMore = () => {
  return (
    <div className="flex flex-col gap-y-2 px-4">
      <div className="flex flex-col justify-start animate-pulse">
        <div className="bg-gray-300 h-4 w-1/3 rounded-lg mb-2"></div>
      </div>

      <div className="flex flex-col justify-start overflow-hidden animate-pulse">
        <div className="bg-gray-300 h-4 w-full rounded-lg mb-2"></div>
        <div className="bg-gray-300 h-4 w-full rounded-lg mb-2"></div>
        <div className="bg-gray-300 h-4 w-full rounded-lg"></div>
      </div>

      <div className="flex justify-center pb-2 mt-2 animate-pulse">
        <div className="bg-gray-300 h-4 w-32 rounded-lg"></div>
      </div>
    </div>
  );
};

export default ShimmerViewMore;
